<template>
    <header class="section page-header">
      <div>
          <router-link class="logo" to="/"><img src="./../../assets/logo.png"/></router-link>
          <nav class="navbar">
              <router-link class="logo-icon" to="/" v-scroll-to="{el:'#home', offset:-104}"><img src="./../../assets/logo.png"/></router-link>             
              <div class="navbar-brand">
                  <a role="button" @click="toggleClass()" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
                      <span aria-hidden="true"></span>
                      <span aria-hidden="true"></span>
                      <span aria-hidden="true"></span>
                  </a>   
              </div>    
              <div v-bind:class="[isActive ? 'is-active' : '']" class="navbar-menu">
                  <div class="menu">
                        <router-link v-for="menuLink in menuLinks" :key="menuLink.id" :to="{ path: menuLink.path}"  class="navbar-item" v-on:click.native="toggleClass();">{{ menuLink.text }}</router-link>                        
                  </div>
              </div>
          </nav>     
        </div>            
    </header>  
      
</template>

<script>
export default {
    props:{
        backgroundImage:{
            type:String
        }
    },    
    data () {
        return {
            isActive: false,
            menuLinks: [
                { path:'/', text: 'Početna' },
                { path:'/onama', text: 'O nama' },
                { path:'/galerija', text: 'Galerija' },
                { path:'/video', text: 'Video' },                
                { path: 'oprema', text: 'Oprema' },                
                { path:'/kontakt', text: 'Kontakt' },                
            ]       
        }
    },
    methods: {
        toggleClass: function(event){
            // Check value
            if(this.isActive){
            this.isActive = false;
            }else{
            this.isActive = true;
            }    
        }
    }
}
</script>

<style lang="scss">
.logo{
    position: absolute;
    top: 2rem;
    z-index: 999;
    left: 14rem;
    img{
        height: 75px;
    }
}
.navbar{
    position: relative;
    padding: 4rem 2rem 4rem 0rem;
    background-color: #fff;
    .logo-icon{
        position: absolute;   
        display: none;
    }
    .navbar-menu{
        text-align: left;
        .menu{
            text-align: right;
            display: inline-block;
            max-width: 1135px;            
            width: 100%;

            a{
                font-family: "Josefin Sans", Helvetica, Arial, sans-serif;
                font-size: 16px;
                font-weight: 600;
                line-height: 1.2;
                letter-spacing: .05em;
                text-transform: uppercase;
                color: #464646;
                cursor: pointer;
                transition: color 0.4s ease;
                margin: 0px 10px;
                
                &:hover{
                    color: #a7cf38;
                }

                &:first-child{
                    display: none;
                }                
            }
            .router-link-exact-active{
                color: #a7cf38;
            }
        } 
     }       
}
@media only screen and (max-width: 991px) {
    .logo{
        left:2rem;
    }
}
@media only screen and (max-width: 768px) {
    .logo{
        display: none;
    }      
    .navbar{
        padding: 1rem 0 0 0; 
        position: fixed;
        width: 100%;
        background: fff;
        z-index: 999;
        top: 0;      
        .logo-icon{
            left: 1rem;
            display: block;
            img{
                height:60px;
            }        
        }        
        .navbar-brand{
            padding-right: 1rem;            
            .logo{
                color: #fff;
                text-decoration: none;
                font-size: 2rem;
            }
            .navbar-burger{
                color: #fff;
                background-color: #a7cf38;
                cursor: pointer;
                display: block;
                position: relative;
                width: 4em;
                height: 4rem;
                margin-left: auto;

                span {
                    background-color: currentColor;
                    display: block;
                    height: 2.5px;
                    left: calc(50% - 15px);
                    position: absolute;
                    -webkit-transform-origin: center;
                            transform-origin: center;
                    transition-duration: 86ms;
                    transition-property: background-color, opacity, -webkit-transform;
                    transition-property: background-color, opacity, transform;
                    transition-property: background-color, opacity, transform, -webkit-transform;
                    transition-timing-function: ease-out;
                    width: 2rem;
                    
                    &:nth-child(1) {
                        top: calc(50% - 6px);
                    }
                    &:nth-child(2) {
                        top: calc(50% - 1px);
                    }

                    &:nth-child(3) {
                        top: calc(50% + 4px);
                    }                    
                }  
                &.is-active{
                    span{
                        &:nth-child(1) {
                            -webkit-transform: translateY(5px) rotate(45deg);
                            transform: translateY(5px) rotate(45deg);
                        }   
                        &:nth-child(2) {
                            opacity: 0;
                        }  
                        &:nth-child(3) {
                            -webkit-transform: translateY(-5px) rotate(-45deg);
                            transform: translateY(-5px) rotate(-45deg);
                        }                                             
                    }
                }                           
            }
        }  
        .navbar-menu{
            padding: 0 1rem 0 2rem;
            .menu {
                a{
                    font-size: 2rem;
                    line-height: 4rem;
                    border-bottom: #f1f1f1 1px solid;
                    display: none;
                    margin-left: 0;
                    cursor: pointer;    
                    font-size: 18px;
                    &:last-child{
                        border-bottom: none;
                    }
                }
            }
            &.is-active {
                .menu{
                    a{
                        display: block;        
                    }
                }
            }
        }              
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Header.vue